import axios from "axios";
import { silentRequest } from "../authConfig";

const API_URL = process.env.REACT_APP_API_URL;

/**
 * @function DownloadStamp download user's stamp
 * @param {Object} payload {instance, account}
 * @returns response data || reject
 */
export const DownloadStamp = (payload) => {
  return new Promise((resolve, reject) => {
    payload.instance
      .acquireTokenSilent({ ...silentRequest, account: payload.account })
      .then((tokenResponse) => {
        axios
          .get(API_URL + "/stamps", {
            headers: {
              Authorization: "Bearer " + tokenResponse.accessToken,
            }
          })
          .then((res) => {
            resolve(res.data);
          },() => {
            reject();
          });
      })
      .catch(() => {
        payload.instance.acquireTokenRedirect(silentRequest);
        reject();
      });
  });
};
